export const getMessengerProfileTypeKey = (profile) => {
  const businessType = String(
    profile?.businessType || profile?.type || "",
  ).toLowerCase();
  if (businessType.includes("retailer")) return "retailerShop";
  if (businessType.includes("whole")) return "wholesellerShop";
  if (businessType.includes("manufacturer")) return "manufacturerShop";
  if (businessType.includes("rawmaterial")) return "rawmaterialShop";
  if (businessType.includes("gem")) return "gemShop";
  if (businessType.includes("usedvehicle")) return "usedVehicleShop";
  if (businessType.includes("used")) return "usedShop";
  if (businessType.includes("homemade")) return "homemadeShop";
  if (businessType.includes("transport")) return "transportShop";
  if (businessType.includes("farm")) return "farmingShop";
  if (businessType.includes("recycle")) return "recycledShop";
  if (businessType.includes("food") || businessType.includes("restaurant")) {
    return "foodShop";
  }
  if (businessType.includes("property")) return "businessPropertyCompany";
  if (businessType.includes("job")) return "jobsCompany";
  if (businessType.includes("service")) return "services";
  return businessType || String(profile?.id || profile?._id || "shop");
};

export const getMessengerProfileTypeLabel = (profile) => {
  const businessType = String(
    profile?.businessType || profile?.type || "",
  ).toLowerCase();
  if (businessType.includes("retailer")) return "Retailer Shop";
  if (businessType.includes("whole")) return "Wholesaler Shop";
  if (businessType.includes("manufacturer")) return "Manufacturer Shop";
  if (businessType.includes("rawmaterial")) return "Raw Material Shop";
  if (businessType.includes("gem")) return "Gems & Jewelry";
  if (businessType.includes("usedvehicle")) return "Used Vehicles";
  if (businessType.includes("used")) return "Used Items";
  if (businessType.includes("homemade")) return "Homemade Shop";
  if (businessType.includes("transport")) return "Transport";
  if (businessType.includes("farm")) return "Farming Shop";
  if (businessType.includes("recycle")) return "Recycled Shop";
  if (businessType.includes("food") || businessType.includes("restaurant")) {
    return "Food & Restaurant";
  }
  if (businessType.includes("property")) return "Real Estate & Property";
  if (businessType.includes("job")) return "Jobs Company";
  if (businessType.includes("service")) return "Services";
  if (profile?.businessType) {
    return profile.businessType
      .replace(/shop$/i, " Shop")
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (character) => character.toUpperCase())
      .trim();
  }
  return profile?.displayName || profile?.name || "Business Profile";
};